var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreySecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 16.9167V19.25M8.16602 11.7002C8.71601 11.6667 9.39404 11.6667 10.266 11.6667H17.7327C18.6047 11.6667 19.2827 11.6667 19.8327 11.7002M8.16602 11.7002C7.47964 11.7422 6.99269 11.8364 6.57705 12.0481C5.91848 12.3837 5.38305 12.9191 5.04749 13.5777C4.66602 14.3264 4.66602 15.3065 4.66602 17.2667V18.9C4.66602 20.8602 4.66602 21.8403 5.04749 22.589C5.38305 23.2475 5.91848 23.783 6.57705 24.1185C7.32574 24.5 8.30583 24.5 10.266 24.5H17.7327C19.6929 24.5 20.673 24.5 21.4216 24.1185C22.0802 23.783 22.6156 23.2475 22.9512 22.589C23.3327 21.8403 23.3327 20.8602 23.3327 18.9V17.2667C23.3327 15.3065 23.3327 14.3264 22.9512 13.5777C22.6156 12.9191 22.0802 12.3837 21.4216 12.0481C21.006 11.8364 20.5191 11.7422 19.8327 11.7002M8.16602 11.7002V9.33333C8.16602 6.11167 10.7777 3.5 13.9993 3.5C17.221 3.5 19.8327 6.11167 19.8327 9.33333V11.7002",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreySecurityIcon);
export default __webpack_public_path__ + "static/media/greySecurityIcon.b793d5d1911cdb211c406daabe03dc7d.svg";
export { ForwardRef as ReactComponent };